import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5222b4d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filterarea" }
const _hoisted_2 = { class: "contentlist" }
const _hoisted_3 = { class: "list-container" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "img" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { class: "text-title" }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 检查类型：")
const _hoisted_12 = { class: "content" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 检查人：")
const _hoisted_14 = { class: "time" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 开始时间： ")
const _hoisted_16 = { class: "time" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 结束时间： ")
const _hoisted_18 = { class: "time" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 检查时长： ")
const _hoisted_20 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item")!
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_dropdown_menu, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_dropdown_item, {
            class: "topdropdown",
            modelValue: _ctx.checkType,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checkType) = $event)),
            options: _ctx.allInspection,
            onChange: _ctx.fChangeSearch
          }, null, 8, ["modelValue", "options", "onChange"]),
          _createVNode(_component_van_dropdown_item, {
            class: "topdropdown",
            modelValue: _ctx.screenType,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.screenType) = $event)),
            options: _ctx.allQuestion,
            onChange: _ctx.fChangeSearch
          }, null, 8, ["modelValue", "options", "onChange"]),
          _createVNode(_component_van_dropdown_item, {
            class: "status",
            modelValue: _ctx.status,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.status) = $event)),
            options: _ctx.allStatus,
            onChange: _ctx.fChangeSearch
          }, null, 8, ["modelValue", "options", "onChange"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "addbtn",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.fGoAdd && _ctx.fGoAdd(...args)))
      }, [
        _createVNode(_component_van_icon, { name: "plus" })
      ]),
      _createVNode(_component_van_pull_refresh, {
        modelValue: _ctx.refreshing,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.refreshing) = $event)),
        onRefresh: _ctx.onRefresh
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_list, {
            loading: _ctx.loading,
            "onUpdate:loading": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.loading) = $event)),
            finished: _ctx.finished,
            "finished-text": "没有更多了",
            "loading-text": "正在加载,请稍后..",
            onLoad: _ctx.onLoad
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.safeList, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "card",
                    key: item.checkId,
                    onClick: ($event: any) => (_ctx.fGoDetail(item))
                  }, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("img", {
                          src: item.coverImg,
                          alt: ""
                        }, null, 8, _hoisted_7)
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(item.title), 1),
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _createElementVNode("span", null, _toDisplayString(item.typeText), 1)
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _hoisted_13,
                          _createElementVNode("span", null, _toDisplayString(item.checkerName), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["time-card", [item.result !== 2 ? 'success-bgc' : 'error-bgc']])
                    }, [
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("span", null, _toDisplayString(item.startTime), 1)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("span", null, _toDisplayString(item.endTime), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("span", null, _toDisplayString(item.timeCount), 1)
                      ])
                    ], 2),
                    _createElementVNode("img", {
                      src: _ctx.statusImg(item.result),
                      alt: "",
                      class: "statusImg"
                    }, null, 8, _hoisted_20)
                  ], 8, _hoisted_4))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["loading", "finished", "onLoad"])
        ]),
        _: 1
      }, 8, ["modelValue", "onRefresh"])
    ])
  ], 64))
}